import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { ImageNotSupported as ImageNotSupportedIcon } from '@mui/icons-material';
import { resolveMonitoringImageUrl } from '../utils/monitoringPresentation';

type Props = {
  thumbnailUrl: string | null;
  imageUrls?: string[] | null;
};

export default function AnnouncementAdminGallery({ thumbnailUrl, imageUrls }: Props) {
  const urls = (imageUrls?.length ? imageUrls : thumbnailUrl ? [thumbnailUrl] : [])
    .map((url) => resolveMonitoringImageUrl(url))
    .filter((url): url is string => Boolean(url));

  const [activeIndex, setActiveIndex] = useState(0);
  const activeUrl = urls[activeIndex] ?? null;

  if (!activeUrl) {
    return (
      <Box
        sx={{
          width: '100%',
          maxWidth: 280,
          aspectRatio: '4 / 3',
          borderRadius: 2,
          bgcolor: 'grey.100',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <ImageNotSupportedIcon color="disabled" />
        <Typography variant="caption" color="text.secondary">
          Aucune photo
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box
        component="img"
        src={activeUrl}
        alt=""
        sx={{
          width: '100%',
          maxWidth: 320,
          aspectRatio: '4 / 3',
          objectFit: 'cover',
          borderRadius: 2,
          bgcolor: 'grey.100',
          display: 'block',
          mb: urls.length > 1 ? 1 : 0,
        }}
      />
      {urls.length > 1 ? (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {urls.map((url, index) => (
            <Box
              key={`${url}-${index}`}
              component="button"
              type="button"
              onClick={() => setActiveIndex(index)}
              sx={{
                p: 0,
                border: 2,
                borderColor: index === activeIndex ? 'primary.main' : 'divider',
                borderRadius: 1,
                overflow: 'hidden',
                cursor: 'pointer',
                bgcolor: 'transparent',
              }}
            >
              <Box
                component="img"
                src={url}
                alt=""
                sx={{ width: 56, height: 56, objectFit: 'cover', display: 'block' }}
              />
            </Box>
          ))}
        </Stack>
      ) : null}
    </Box>
  );
}
